import React, { useState } from "react";
import noImageFound from "../../../assets/images/CardTypeIcons/noImageFound.png";
import classes from "./SeriesCard.module.scss";
import Tooltip from "../ToolTip/Tooltip";
import InforIcon from "../SvgIcons/DistributeIcons/InfoIcon";
import { RiFileCopyLine, RiDeleteBin6Line } from "react-icons/ri";
import { MdOutlineTimer } from "react-icons/md";
import { FormattedMessage } from "react-intl";
const SeriesCard = ({
  seriesData,
  handleDelete,
  isDeleteVisible,
  imageClick,
  isCheckboxVisible,
  isChecked,
  handleCheckboxChange,
  isInfoIconVisible,
  infoText,
  isCopyIconVisible,
  isHistoryIconVisible,
  handleHistroyClick,
  handleCopyClick,
}) => {
  const [hover, setHover] = useState(false);
  return (
    <div className={classes.seriesCardContainer}>
      <div className={classes.seriesCard}>
        <div
          className={classes.imageContainer}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
        >
          {isDeleteVisible && (
            <div className={classes.deleteIcon} onClick={handleDelete}>
              <Tooltip
                content={<FormattedMessage id="DELETE_TXT" />}
                direction="right"
              >
                <RiDeleteBin6Line size={20} />
              </Tooltip>
            </div>
          )}
          {isCopyIconVisible && (
            <div className={classes.copyIcon} onClick={handleCopyClick}>
              <Tooltip
                content={<FormattedMessage id="P_COPY" />}
                direction="right"
              >
                <RiFileCopyLine size={20} />
              </Tooltip>
            </div>
          )}
          {isHistoryIconVisible && (
            <div className={classes.historyIcon} onClick={handleHistroyClick}>
              <Tooltip
                content={<FormattedMessage id="DISTRIBUTE_HISTORYTAG" />}
                direction="right"
              >
                <MdOutlineTimer size={20} />
              </Tooltip>
            </div>
          )}
          {isCheckboxVisible && (
            <div className={classes.checkbox}>
              <input
                className={classes.series}
                type="checkbox"
                checked={isChecked}
                onChange={handleCheckboxChange}
              />
            </div>
          )}
          <img
            className={hover ? classes.imageHover : classes.image}
            src={seriesData?.ImageUrl ? seriesData?.ImageUrl : noImageFound}
            loading="lazy"
            alt="series thumbnail"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = noImageFound;
            }}
            onClick={imageClick}
          />
        </div>

        <div className={classes.detailsContainer}>
          <div title={seriesData?.Name} className={classes.heading}>
            {seriesData?.Name?.length > 38
              ? seriesData?.Name.slice(0, 38) + " . . ."
              : seriesData?.Name}
          </div>
          <div className={classes.info} title={infoText}>
            {isInfoIconVisible && (
              // <Tooltip content={infoText} direction="bottom">
              // </Tooltip>
              <InforIcon
                fill={seriesData?.PublishedbyMe ? "#31C56F" : "#005cc8"}
                stroke={seriesData?.PublishedbyMe ? "#31C56F" : "#005cc8"}
              />
            )}
            <div className={classes.noOfClasses}>
              <div className={classes.itemCountText}>
                {seriesData?.ItemCount}
              </div>
              <div className={classes.classText}>Classes</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SeriesCard;
